(function () {
    const onClickOption = function (e) {
        const o = this;
        const src = o.image.getAttribute('data-entry-relation-manageable').split(':');
        const selected = !!src[1] ? src[1].split(',') : [];

        const option = e.currentTarget;
        const value = e.currentTarget.getAttribute('data-value');
        if (selected.indexOf(value) === -1) {
            option.classList.add('entryRelationManage__option--selected');
        } else {
            option.classList.remove('entryRelationManage__option--selected');
        }
        const newValues = [];
        const selectedOptions = this.element.querySelectorAll('.entryRelationManage__option--selected');
        for (let j = 0; j < selectedOptions.length; j++) {
            newValues.push(selectedOptions[j].getAttribute('data-value'));
        }
        o.image.setAttribute('data-entry-relation-manageable', src[0] + ':' + newValues.join(','));

        const url = o.image.getAttribute('data-entry-relation-manageable-url');
        fetch(url, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')['content']
            },
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            body: JSON.stringify({keys: newValues})
        })
            .catch(function (err) {
                console.error(err);
            });
    };

    const Editor = function (options) {
        this.image = null;
        this.element = options.element;
        this.options = this.element.querySelectorAll('.entryRelationManage__option');
        const o = this;
        for (let j = 0; j < this.options.length; j++) {
            this.options[j].addEventListener('click', function (e) {
                onClickOption.call(o, e);
            });
        }
    };
    const fn = Editor.prototype;
    fn.resetSelect = function () {
        const options = this.element.querySelectorAll('.entryRelationManage__option--selected');
        for (let j = 0; j < options.length; j++) {
            options[j].classList.remove('entryRelationManage__option--selected');
        }
    };
    fn.reset = function (imageElement) {
        this.resetSelect();
        this.image = imageElement;
        const src = this.image.getAttribute('data-entry-relation-manageable').split(':');
        if (!!src[1]) {
            const selected = src[1].split(',');
            for (let i = 0; i < selected.length; i++) {
                const element = document.querySelector('.entryRelationManage__option[data-value="' + selected[i] + '"]');
                if (!!element) {
                    element.classList.add('entryRelationManage__option--selected');
                }
            }
        }
    };
    const init = function (editorElement) {
        const editor = new Editor({element: editorElement});
        const select = editorElement.querySelector('.entryRelationManage__select');
        const control = editorElement.querySelector('.entryRelationManage__visibilityControl');

        control.addEventListener('click', function () {
            select.classList.toggle('entryRelationManage__select--visible')
        });

        const setImage = function () {
            const url = !!window.location.hash ? decodeURIComponent(window.location.hash.substr(1)) : '';
            const image = document.querySelector('[data-photo-viewer-image="' + url + '"][data-entry-relation-manageable]');
            if (!!url && !!image) {
                select.style.display = 'flex';
                control.style.display = 'block';
                editor.reset(image);
            } else {
                select.style.display = 'none';
                control.style.display = 'none';
            }
        };

        window.addEventListener('hashchange', setImage);
        setImage();
    };
    window.addEventListener('load', function(){
        document.querySelectorAll('[ data-entry-relation-manageable]').forEach(init);
    });

}());
